import React, { Component } from "react";
import classNames from "classnames";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";

const styles = {
  container: {
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderStyle: "inset",
    borderRadius: 4,
    display: "flex",
    alignItems: "center",
    minHeight: 20,
    "& >input": {
      fontSize: "0.875rem",
      fontWeight: 500,
      width: 40,
      border: "none",
      textAlign: "center",
      "&:disabled": {
        background: "none"
      }
    }
  },
  button: {
    minWidth: 0,
    minHeight: 0,
    height: "100%",
    padding: [[0, 12]],
    borderRadius: 0,
    "&:first-child": {
      borderRight: "1px solid rgba(0, 0, 0, 0.23)"
    },
    "&:last-child": {
      borderLeft: "1px solid rgba(0, 0, 0, 0.23)"
    }
  }
};
class Counter extends Component {
  decrement = () => {
    this.props.onChange(this.props.value - 1);
  };
  increment = () => {
    this.props.onChange(this.props.value + 1);
  };
  handleInput = event => {
    this.props.onChange(event.target.value);
  };
  render() {
    const { classes, value, disabled, className, style } = this.props;
    return (
      <div className={classNames(classes.container, className)} style={style}>
        <Button
          onClick={this.decrement}
          className={classes.button}
          disabled={disabled}
        >
          -
        </Button>
        <input
          type="text"
          value={value}
          disabled={disabled}
          onChange={this.handleInput}
        />
        <Button
          onClick={this.increment}
          className={classes.button}
          disabled={disabled}
        >
          +
        </Button>
      </div>
    );
  }
}
Counter.defaultProps = {
  disabled: false
};
export default withStyles(styles)(Counter);



// WEBPACK FOOTER //
// ./src/components/Counter.js